import React from "react";
import { JameoLogo } from "../../components/JameoLogo";

import { ReactComponent as Skateboard } from "./skateboard.svg";

import styles from "./NotAvailableMobileContainer.module.scss";
import { useTranslation } from "react-i18next";

const NotAvailableMobileContainer = (props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <JameoLogo />
      <div>
        <Skateboard />
        <p>{t("mobile.please_roll")}</p>
        <p>{t("mobile.see_you_soon")}</p>
      </div>
      <div></div>
    </div>
  );
};

export default NotAvailableMobileContainer;
